<div [class.create-user-container]="!isDialogMode">
  <mat-card [class.create-user-card]="!isDialogMode" [class.dialog-card]="isDialogMode">
    <mat-card-header>
      <img src="assets/images/logo_full_900.png" alt="Logo" />
    </mat-card-header>
    <mat-card-content style="width: 100%;">
        @if (!submitted) {
            <div style="display: flex;">
                <form [formGroup]="addUserForm" (ngSubmit)="submit()" class="form">
                    
                    <div class="form-row row-2" style="margin-bottom:0px;">
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>First Name</mat-label>
                            <input matInput formControlName="firstName">
                            <mat-error *ngIf="addUserForm.get('firstName')?.hasError('required')">
                            First Name is required
                            </mat-error>
                        </mat-form-field>
    
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="lastName">
                            <mat-error *ngIf="addUserForm.get('lastName')?.hasError('required')">
                            Last Name is required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" placeholder="Your Email">
                        <mat-icon matSuffix>
                            <i class="fa-solid fa-envelope"></i>
                        </mat-icon>
                        <mat-error *ngIf="addUserForm.get('email')?.hasError('required')">
                        Email is required
                        </mat-error>
                        <mat-error *ngIf="addUserForm.get('email')?.hasError('email')">
                        Invalid email format
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Password</mat-label>
                        <input matInput formControlName="password" placeholder="Your Password" type="password">
                        <mat-icon matSuffix>key</mat-icon>
                        <mat-error *ngIf="addUserForm.get('password')?.hasError('required')">
                        Password is required
                        </mat-error>
                        <mat-error *ngIf="addUserForm.get('password')?.hasError('minlength')">
                        Password must be at least 6 characters
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Confirm Password</mat-label>
                        <input matInput formControlName="passwordConfirm" type="password">
                        <mat-error *ngIf="addUserForm.hasError('mismatch')">
                        Passwords do not match
                        </mat-error>
                    </mat-form-field>

                    <div class="terms-agreement">
                        <mat-slide-toggle formControlName="termsAccepted" (toggleChange)="agreementChange()">
                            I acknowledge and agree to all Horizinns <a href="/terms">Terms &amp; Conditions</a> and <a href="/privacy">Privacy Policy</a>
                        </mat-slide-toggle>
                        <mat-error *ngIf="addUserForm.get('termsAccepted')?.hasError('required') && addUserForm.get('termsAccepted')?.touched">
                            You must agree to the terms & conditions
                        </mat-error>
                    </div>

                    <div class="center">
                        <button mat-flat-button class="metallic-text-btn-blue" type="submit">
                            Sign Up
                        </button>
                    </div>
                </form>
            </div>
        }
        @if (submitted) {
            <div style="display: flex; width: 100%;flex-direction: column;justify-content: center;align-items:center;margin-left:auto;margin-right:auto;text-align: center;">
                @if (loading) {
                    <div class="center">
                        <app-loader></app-loader>
                        <p>Registering your account...</p>
                    </div>
                } @else {
                    <div style="width:100%;">
                        <app-success-error [success]="successful"></app-success-error>
                    </div>
                    <div style="width:100%;">
                        @if(successful) {
                            Please check your email to verify your registration.
                        } @else {
                            We had a problem while attempting to register you.
                        }
                    </div>
                }
            </div>
        }
    </mat-card-content>
  </mat-card>
</div>